<template>
  <div class="footer-container">
    <address-phone></address-phone>
  </div>
</template>

<script>
import AddressPhone from "./AddressPhone"
export default {
  name: "Index",
  components: {
    AddressPhone
  }
};
</script>

<style lang="scss" scoped>
.footer-container {
  height: 400px;
  background: #434343;
  overflow: hidden;
}
</style>
